import React from "react";
import "../css/AcUnIstallation.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function AcUnIstallation() {
  return (
    <>
         <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Expert AC Uninstallation Services</p>

          <h1 className="ac-hero-title">
           Safe, Efficient, and Hassle
            <br />
           -Free
          </h1>

          <p className="ac-hero-subtitle">
            Get all kinds of AC service at your doorstep in 30 minutes. Schedule
            your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for All AC Uninstallation Needs</h2>

            <p>Your Trusted Partner for All AC Uninstallation Needs
When it comes to air conditioning systems, ensuring proper installation and uninstallation is crucial for optimal performance. 
              <a className="ac-link" href="#">Jay Ambe AC Service</a> specialize in providing comprehensive <strong>air conditioner uninstallation services</strong> tailored to meet the unique needs of our clients. With years of experience in the HVAC industry, our skilled technicians are equipped to handle all types of air conditioning units, ensuring a seamless and hassle-free process.
            </p>

            <p>
             Our commitment to customer satisfaction sets us apart from the competition. We understand that uninstallation can be a daunting task, whether you’re relocating your unit or upgrading to a newer model. That’s why we prioritize efficiency and safety during every job. Our team meticulously assesses your specific requirements before commencing the uninstallation process, taking care to disconnect electrical components and refrigerant lines safely.
            </p>

            <p>
            At Jau Ambe AC Service, we pride ourselves on using state-of-the-art tools and techniques to ensure that your old unit is removed without causing any damage to your property. Our trained professionals not only guarantee an efficient service but also provide valuable insights into how you can maintain your new cooling system once installed.
            </p>

            <p>
        We offer flexible scheduling options to accommodate your busy lifestyle while keeping costs competitive without compromising quality. Whether you have a window unit or a central air system, you can trust Jay Ambe AC Service for reliable uninstallation services tailored specifically for you..
            </p>

            <p>
          Additionally, we believe in transparent communication with our clients throughout the entire process. You will always know what steps we’re taking and why they matter for both safety and functionality.
            </p>

            <p>
                Choose Jay Ambe AC Service for all your air conditioner uninstallation needs and experience peace of mind knowing that experts are handling every aspect with care!
            </p>

          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/uninstallation.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
 <Herolast  />
      <Footer  />
     
    </>
  );
}
